import React, { useEffect, useState } from "react";
import api from "../../lib/api";

const KIND_META = {
  reservation_created: { color: "bg-[#0AA89C]", icon: "•" },
  reservation_cancelled: { color: "bg-red-500", icon: "•" },
  reservation_confirmed: { color: "bg-emerald-500", icon: "•" },
  preference_created: { color: "bg-sky-500", icon: "•" },
  payment_created: { color: "bg-sky-600", icon: "•" },
  payment_approved: { color: "bg-emerald-600", icon: "•" },
  payment_rejected: { color: "bg-red-500", icon: "•" },
  payment_refunded: { color: "bg-amber-500", icon: "•" },
  contract_created: { color: "bg-indigo-500", icon: "•" },
  contract_sent: { color: "bg-indigo-500", icon: "•" },
  contract_accepted: { color: "bg-indigo-700", icon: "•" },
  checkin_created: { color: "bg-slate-500", icon: "•" },
  checkin_released: { color: "bg-amber-500", icon: "•" },
  checkin_link_sent: { color: "bg-sky-500", icon: "•" },
  checkin_completed: { color: "bg-emerald-500", icon: "•" },
  checkout_completed: { color: "bg-emerald-700", icon: "•" },
  email_failed: { color: "bg-red-400", icon: "•" },
  trash_moved: { color: "bg-slate-400", icon: "•" },
  trash_restored: { color: "bg-slate-500", icon: "•" },
  trash_purged: { color: "bg-red-600", icon: "•" },
};

export default function ReservationTimeline({ reservationId }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [code, setCode] = useState("");

  useEffect(() => {
    if (!reservationId) return;
    setLoading(true);
    api.get(`/admin/reservations/${reservationId}/timeline`)
      .then((r) => { setEvents(r.data.events || []); setCode(r.data.code || ""); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [reservationId]);

  if (loading) return <div className="text-sm text-slate-500">Carregando timeline…</div>;
  if (!events.length) return (
    <div className="border border-dashed border-slate-300 rounded-md p-8 text-center text-sm text-slate-500">
      Nenhum evento registrado ainda para a reserva {code || reservationId?.slice(0, 8)}.
    </div>
  );

  return (
    <div className="max-w-3xl" data-testid="reservation-timeline">
      <div className="text-xs uppercase tracking-widest text-slate-500 mb-4">Timeline · {code}</div>
      <ol className="relative border-l border-slate-200 ml-3">
        {events.map((ev) => {
          const meta = KIND_META[ev.kind] || { color: "bg-slate-400" };
          return (
            <li key={ev.id} className="mb-6 ml-4" data-testid={`tl-event-${ev.kind}`}>
              <span className={`absolute -left-[7px] w-3 h-3 rounded-full ${meta.color} ring-4 ring-white`}></span>
              <div className="flex items-baseline justify-between gap-3">
                <div>
                  <div className="text-sm font-medium text-[#22302E]">{ev.title}</div>
                  {ev.description && <div className="text-xs text-slate-600 mt-0.5">{ev.description}</div>}
                </div>
                <time className="shrink-0 text-[11px] text-slate-500 whitespace-nowrap">{ev.at?.slice(0, 19).replace("T", " ")}</time>
              </div>
              <div className="mt-1 text-[11px] text-slate-500">
                {ev.actor && <span className="mr-2">por {ev.actor}</span>}
                {ev.entity && <span className="mr-2">· {ev.entity}</span>}
                {ev.data?.message_id && <span>· msg <code>{String(ev.data.message_id).slice(0, 12)}…</code></span>}
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
